import React from "react";
import { Link } from "react-router-dom";
import { branding } from "@/config/branding";
import { Button } from "@/components/ds";
import { BrandLogo } from "@/components/BrandLogo";

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center" data-testid="public-logo">
            <BrandLogo className="h-8" />
          </Link>
          <nav className="flex items-center gap-2 sm:gap-4">
            <Link to="/pricing" className="hidden px-3 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:block" data-testid="public-pricing-link">Pricing</Link>
            <Link to="/partners" className="hidden px-3 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:block" data-testid="public-partners-link">Partners</Link>
            <Link to="/login" data-testid="public-login-link"><Button variant="ghost" size="sm">Sign in</Button></Link>
            <Link to="/pricing" data-testid="public-register-link"><Button size="sm">Get started</Button></Link>
          </nav>
        </div>
      </header>
      <main>{children}</main>
      <footer className="border-t border-slate-200 bg-slate-50">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-8 text-sm text-slate-500 sm:flex-row sm:px-6">
          <p>© {new Date().getFullYear()} {branding.productName}. All rights reserved.</p>
          <nav className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-slate-900" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-900" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <a href={`mailto:${branding.supportEmail}`} className="hover:text-slate-900">{branding.supportEmail}</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
